@if (isOpen()) {
  <div class="fixed inset-0 z-50 flex items-end sm:items-center justify-center p-0 sm:p-4 overflow-x-hidden overflow-y-auto outline-none focus:outline-none">
    <!-- Backdrop -->
    <div 
      class="fixed inset-0 bg-black/60 backdrop-blur-sm transition-opacity animate-fade-in"
      (click)="closable() ? onClose() : null"
    ></div>

    <!-- Modal Content: Bottom Sheet on Mobile (< sm), Centered Dialog on sm+ -->
    <div class="relative w-full max-w-lg mx-0 sm:mx-auto my-0 sm:my-6 z-50 animate-slide-up-sheet sm:animate-slide-up">
      <div class="relative flex flex-col w-full bg-surface border-t sm:border border-border-default rounded-t-[32px] sm:rounded-[32px] rounded-b-none sm:rounded-b-[32px] overflow-hidden shadow-[0_20px_60px_rgba(0,0,0,0.2)] dark:shadow-[0_20px_60px_rgba(0,0,0,0.5)] max-h-[90vh] sm:max-h-[85vh]">
        
        <!-- Mobile drag handle pill -->
        <div class="flex items-center justify-center pt-3 pb-1 sm:hidden cursor-pointer" (click)="closable() ? onClose() : null">
          <div class="w-12 h-1.5 rounded-full bg-slate-300 dark:bg-slate-700 active:bg-slate-400 transition-colors"></div>
        </div>

        <!-- Header -->
        <div class="flex items-center justify-between px-6 py-4 sm:py-5 border-b border-border-subtle">
          <h3 class="text-lg sm:text-xl font-bold text-content flex items-center gap-3">
            <div class="w-8 h-8 rounded-lg bg-brand-500/10 border border-brand-500/20 flex items-center justify-center text-brand-500 shrink-0">
              <svg class="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z"/>
              </svg>
            </div>
            <span class="truncate">{{ title() }}</span>
          </h3>
          @if (closable()) {
            <button 
              (click)="onClose()"
              class="w-9 h-9 sm:w-10 sm:h-10 rounded-xl bg-surface-subtle border border-border-default flex items-center justify-center text-content-subtle hover:text-content hover:bg-surface-hover transition-all active:scale-95 group cursor-pointer shrink-0"
              title="Fermer"
            >
              <svg class="w-5 h-5 group-hover:rotate-90 transition-transform" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12"/>
              </svg>
            </button>
          }
        </div>

        <!-- Body -->
        <div class="relative p-6 sm:p-8 flex-auto overflow-y-auto pb-[calc(env(safe-area-inset-bottom)+1.5rem)] sm:pb-8 text-content-sub">
          <ng-content></ng-content>
        </div>

      </div>
    </div>
  </div>
}